module.exports = __webpack_public_path__ + "img/imageedit_1_2770519114.8422cc3e.gif";